import XeroInvoiceStatus from "./XeroInvoiceStatus";
import XeroFeatureFlagCheck from "../../../../../utils/XeroFeatureFlagCheck";

function XeroInvoiceStatusWrapper() {
    return (
        <XeroFeatureFlagCheck>
            <XeroInvoiceStatus />
        </XeroFeatureFlagCheck>
    )
}

export default XeroInvoiceStatusWrapper;